import { FC } from 'react';
import CustomSelect from '../../../../components/customSelect';

interface IProperties {
  available: string[];
  containsProps: string[];
  handleChangePills?: (index: number, prop: string) => void;
}

const Properties: FC<IProperties> = ({ available, containsProps, handleChangePills }: IProperties) => {
  const formatListProperties = () => available?.filter((elemento: string) => containsProps.indexOf(elemento) === -1);

  return (
    <div className="containerProperties">
      <div className="title">Propiedades remarcadas</div>
      <div className="containterProperties">
        <div className="defaultItems">Perfil</div>
        <div className="defaultItems">Gama</div>

        <>
          <div className="containerSelect">
            <CustomSelect
              items={formatListProperties()}
              defaultValue="Propiedad 1"
              value={containsProps && containsProps.length > 0 ? containsProps[0] : ''}
              onChangeSelect={e => handleChangePills?.(0, e)}
            />
          </div>
          <div className="containerSelect">
            <CustomSelect
              items={formatListProperties()}
              defaultValue="Propiedad 2"
              value={containsProps && containsProps.length > 1 ? containsProps[1] : ''}
              onChangeSelect={e => handleChangePills?.(1, e)}
            />
          </div>
          <div className="containerSelect">
            <CustomSelect
              items={formatListProperties()}
              defaultValue="Propiedad 3"
              value={containsProps && containsProps.length > 2 ? containsProps[2] : ''}
              onChangeSelect={e => handleChangePills?.(2, e)}
            />
          </div>
        </>
      </div>
    </div>
  );
};
export default Properties;
